// Scoped shadcn semantic tokens for homepage scroll beats (light shell + player hue).

import type { CSSProperties } from 'react';
import {
  getColorStop,
  type PlayerColorFamily,
  type PlayerColorStop,
} from '@/styles/playerColors';

/**
 * Light-mode semantics (mirrors `:root` in `styles/tailwind.css`) so the
 * header subtree ignores global `.dark` while sitting over light pastel fills.
 * Player hue overrides are merged on top.
 */
export function getHomeBeatHeaderScopeStyle(
  family: PlayerColorFamily
): CSSProperties {
  const v = (stop: PlayerColorStop) => getColorStop(family, stop);

  return {
    colorScheme: 'light',
    '--background': 'var(--color-white)',
    '--foreground': 'var(--color-neutral-950)',
    '--card': 'var(--color-white)',
    '--card-foreground': 'var(--color-neutral-950)',
    '--popover': 'var(--color-white)',
    '--popover-foreground': 'var(--color-neutral-950)',
    '--muted': 'var(--color-neutral-100)',
    '--muted-foreground': 'var(--color-neutral-500)',
    '--border': 'var(--color-neutral-200)',
    '--input': 'var(--color-neutral-200)',
    '--destructive': 'var(--color-red-500)',
    '--destructive-foreground': 'var(--color-red-700)',
    '--primary': v('500'),
    '--primary-foreground': v('50'),
    '--ring': v('400'),
    '--accent': v('100'),
    '--accent-foreground': v('900'),
    '--secondary': v('200'),
    '--secondary-foreground': v('950'),
  } as CSSProperties;
}
